import { useTranslation } from 'react-i18next'

import { ProductVisibility } from '~/portal/components/ProductTile/ProductVisibility'
import { RequestAccessButton } from '~/portal/components/ProductTile/RequestAccessButton'
import { TooltipWrapper } from '~/portal/components/TooltipWrapper'
import { useEntitlements } from '~/portal/hooks/useEntitlements.ts'
import { LandingProduct } from '~/portal/types/product'

interface ProductTileActionProps {
  isPreview?: boolean;
  accentColor?: string;
  portalName?: string;
  userFullName?: string;
  product: LandingProduct;
  loggedIn?: boolean;
}

export const ProductTileAction = ({
  isPreview,
  accentColor,
  portalName,
  userFullName,
  product,
  loggedIn,
}: ProductTileActionProps) => {
  const { t } = useTranslation()

  const { canAccess } = product

  const isRequestPending = !!product.accessRequest

  const { requestAccessEnabled } = useEntitlements()

  if (canAccess) {
    return null
  }

  if (isPreview) {
    return <ProductVisibility isPreview={isPreview} accentColor={accentColor} />
  }

  if (loggedIn && requestAccessEnabled) {
    return (
      <TooltipWrapper
        content={
          isRequestPending
            ? t('portal.landingPage.productTile.requestAccess.tooltip.pending')
            : t('portal.landingPage.productTile.requestAccess.tooltip.request', { portalName })}
        trigger="hover"
        defaultComp={
          <RequestAccessButton
            accentColor={accentColor}
            isPending={isRequestPending}
            product={product}
            userFullName={userFullName}
          />
        }
        className={isRequestPending ? 'auto' : 'w-60'}
        placement="bottom"
      />
    )
  }

  return (
    <TooltipWrapper
      content={t(
        loggedIn
          ? 'portal.landingPage.productTile.private.tooltip.message'
          : 'portal.landingPage.productTile.loggedOut.tooltip.message'
      )}
      trigger="hover"
      defaultComp={<ProductVisibility accentColor={accentColor} />}
      className="max-w-60"
      placement="bottom"
      displayOnMobile
    />
  )
}